/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import {
  Grid,
  Paper,
  Box,
  Tab,
  Tabs,
  Button,
  Popover,
  List,
  ListItem,
  Container,
  Link,
  Typography,
  CircularProgress,
} from '@mui/material';
import '../../../Main.styles.css';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import GroutColorsAndSize from './GroutColorsAndSize';
import TilePattern from './TilePattern';
import Render from '../../../../services/render/Render';
import { useAppSelector } from '../../../../store/hooks';
import { groutWidthData, roomData, tilePattern } from '../room.data';
import defaultTileImg from '../../../../assets/room-scene/haylo.png';
// import defaultTileImg from '../../../../assets/images/default-tiles/Tile.jpg';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  deleteGroutColorData,
  setGroutColorData,
  setSelectedTileData,
} from '../../../../store/tile.slice';
import { useDispatch } from 'react-redux';
import SelectRoom from '../SelectRoom/SelectRoom.screen';
import SelectGroutColors from '../../Tile/SelectGroutColors/SelectGroutColors';
import BottomDrawer from '../../../../components/BottomDrawer/BottomDrawer';
import { useRoomScene } from '../../../User/hooks/useRoomScene';
import { setLoader } from '../../../../store/user.slice';
import SignIn from '../../../User/SignIn/SignIn.screen';
import MainLogo from '../../../../components/MainLogo/MainLogo.components';
import { store } from '../../../../store/store';

// Start Tab Code
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ div: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ViewRoom = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);

  const handleBack = () => {
    navigate('../visualizer/configure-tile');
  };

  const opensecond = Boolean(anchorEl);
  const id = opensecond ? 'simple-popover' : undefined;

  const { saveRoomScene, deleteRoomSceneById } = useRoomScene();

  React.useEffect(() => {
    dispatch(setLoader(true));
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const mapRoomSceneValue = (tile, grout, room) => {
    const { tileOne, tileTwo, tileThree, groutWidth, groutColor, name, id } = grout || {};
    const { shape, size } = tile || {};
    return {
      tileShapeLabel: shape?.label,
      tileShapeAspect: shape?.aspect,
      tileSizeLabel: size?.label,
      tileSizeWidth: size?.width,
      tileSizeHeight: size?.height,
      tileOneId: tileOne?.id,
      tileOneName: tileOne?.name,
      tileOneBackgroundColor: tileOne?.backgroundColor,
      tileTwoId: tileTwo?.id,
      tileTwoName: tileTwo?.name,
      tileTwoBackgroundColor: tileTwo?.backgroundColor,
      tileThreeId: tileThree?.id,
      tileThreeName: tileThree?.name,
      tileThreeBackgroundColor: tileThree?.backgroundColor,
      tileTwoGroutWidth: groutWidth?.label1 || groutWidthData[2]?.label1,
      tileThreeGroutWidth: groutWidth?.label2 || groutWidthData[2]?.label2,
      roomId: room?.id,
      roomName: room?.name,
      // tileOneColor: '',
      // tileOneGroutColor: '',
      // tileOneGroutWidth: '',
      // tileTwoColor: '',
      // tileTwoGroutColor: '',
      // tileTwoGroutWidth: '',
      // tileThreeColor: '',
      // tileThreeGroutColor: '',
      // tileThreeGroutWidth: '',
    };
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const { selectedTileData, selectedGroutColorData } = useAppSelector((state) => {
    return state.tile;
  });
  const { userData } = useAppSelector((state) => {
    return state.user;
  });

  const { user, token } = userData || {};
  const userId = user?._id;

  React.useEffect(() => {
    if (!userId) {
      setSaveButton('Save Scene');
      setUserSceneId(null);
    }
  }, [userId]);

  React.useEffect(() => {
    if (!selectedTileData) {
      dispatch(
        setSelectedTileData({
          shape: {
            label: 'Square',
            aspect: 1,
          },
          size: {
            label: '12 x 12"',
            width: 10,
            height: 10,
          },
          tile: null,
        }),
      );
    }
  }, [selectedTileData]);

  React.useEffect(() => {
    if (!selectedGroutColorData) {
      dispatch(
        setGroutColorData({
          tileOne: {
            id: '#640',
            name: 'Arctic White',
            backgroundColor: '#f2f3f4',
          },
          tileTwo: {
            id: '#381',
            name: 'Bright White',
            backgroundColor: '#ebe9df',
          },
          tileThree: {
            id: '#641',
            name: 'Cool White',
            backgroundColor: '#edf1f3',
          },
          groutWidth: { id: '3/16', jointWidth: 0.188, label1: '3/16"', label2: '(4.8mm)' },
          selected: 'tileOne',
        }),
      );
    }
    // else if (!selectedGroutColorData?.groutWidth) {
    //   dispatch(
    //     setGroutColorData({
    //       ...selectedGroutColorData,
    //       groutWidth: { id: '3/16', jointWidth: 0.188, label1: '3/16"', label2: '(4.8mm)' },
    //       selected: 'tileOne',
    //     }),
    //   );
    // }
  }, [selectedGroutColorData]);

  const params = useParams();
  const { state } = useLocation();

  React.useEffect(() => {
    if (!(params?.room && roomData.some((r) => r.id === params?.room))) {
      navigate('../');
    }
  }, [params]);

  const groutColor =
    (selectedGroutColorData &&
      selectedGroutColorData[selectedGroutColorData.selected]?.backgroundColor) ||
    '#f2f3f4';
  const groutWidth = selectedGroutColorData?.groutWidth || groutWidthData[2];
  const tileImage = (selectedTileData && selectedTileData?.tile) || defaultTileImg;
  const room = roomData.find((r) => r.id === params?.room);
  const installation =
    (selectedTileData && selectedTileData?.installation) || tilePattern[0].installation;

  const { surface } = room || {};
  const w = (selectedTileData && selectedTileData?.size?.width) || 12;
  const h = (selectedTileData && selectedTileData?.size?.height) || 12;

  const [roomSceneDimension, setRoomSceneDimension] = React.useState(null);

  const onRoomSceneLoad = (img) => {
    dispatch(setLoader(false));
    setRoomSceneDimension({ height: img.target.offsetHeight, width: img.target.offsetWidth });
  };

  const [roomSceneData, setRoomSceneData] = React.useState(null);
  const dispatch = useDispatch();

  const gW = groutWidth?.jointWidth * surface[0]?.inchToPixelFactor;

  const sendColorDL = (color) => {
    const { dataLayer } = window;
    dataLayer.push({
      event: 'selectedColor',
      color,
    });
  };

  const sendPatternDL = (pattern) => {
    const { dataLayer } = window;
    dataLayer.push({
      event: 'selectedPattern',
      pattern,
    });
  };

  React.useEffect(() => {
    sendColorDL(groutColor);
  }, [groutColor]);

  React.useEffect(() => {
    sendPatternDL(installation);
  }, [installation]);

  React.useEffect(() => {
    setSaveButton('Save Scene');
    setUserSceneId(null);
    const updateRoomData = {
      ...room,
      tile: tileImage,
      dimension: roomSceneDimension,
      tileWidth: w * surface[0]?.inchToPixelFactor + gW,
      tileHeight: h * surface[0]?.inchToPixelFactor + gW,
      groutWidth: gW,
      groutColor: groutColor,
      installation,
    };

    setRoomSceneData({ ...updateRoomData });
  }, [tileImage, groutColor, roomSceneDimension, groutWidth, params, installation]);

  const canvasRef = React.useRef();

  const [saveButton, setSaveButton] = React.useState('Save Scene');
  const [userSceneId, setUserSceneId] = React.useState(null);

  const unSaveScene = (label, id) => {
    setSaveButton(label);
    setUserSceneId(id);
  };

  // const [test, setTest] = React.useState(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const {
      user: { userData },
    } = store.getState();

    if (!userData?.token) {
      roomViewDialogOpen('signIn');
      return;
    }

    if (saveButton === 'Unsave Scene' && userSceneId) {
      deleteRoomSceneById(userSceneId, unSaveScene);
      return;
    }

    // const ogCanvas = canvasRef?.current?.canvasParentRef.current.children[0];
    const ogCanvas = document.getElementById('defaultCanvas0');
    const context = ogCanvas.getContext('2d');

    const image1 = new Image();
    image1.src = ogCanvas.toDataURL();

    const image2 = new Image();
    image2.src = room.src;

    const canvas = document.createElement('canvas');
    canvas.width = ogCanvas?.width;
    canvas.height = ogCanvas?.height;

    const newContext = canvas.getContext('2d');
    image1.onload = () => {
      newContext.drawImage(image1, 0, 0, canvas.width, canvas.height);
      newContext.drawImage(image2, 0, 0, canvas.width, canvas.height);
      const dataURL = canvas.toDataURL();

      function dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
        else byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });
      }

      let blob;
      if (dataURL) {
        blob = dataURItoBlob(dataURL);
        // setTest(dataURL);
      }

      const payload = mapRoomSceneValue(selectedTileData, selectedGroutColorData, roomSceneData);
      if (blob) {
        saveRoomScene({ ...payload, file: blob }, unSaveScene);
      }
    };

    // setAnchorEl(event.currentTarget);
    // saveRoomScene()
  };

  const handleColorClick = (selected) => {
    dispatch(
      setGroutColorData({
        ...selectedGroutColorData,
        ...selected,
      }),
    );
  };

  const navigate = useNavigate();

  const handleColorDelete = (deleted) => {
    const d = { ...selectedGroutColorData, ...{ selected: deleted } };
    delete d[deleted];
    dispatch(deleteGroutColorData(d));
  };

  const handleAddColor = (add) => {
    dispatch(
      setGroutColorData({
        ...selectedGroutColorData,
        selected: add,
      }),
    );
    roomViewDialogOpen('selectGroutColor');
  };

  const handleGroutWidth = (groutWidth) => {
    dispatch(
      setGroutColorData({
        ...selectedGroutColorData,
        groutWidth,
      }),
    );
  };

  const handlePattern = (installation) => {
    dispatch(
      setSelectedTileData({
        ...selectedTileData,
        installation,
      }),
    );
  };

  const [dialog, setDialog] = React.useState(false);
  const [dialogView, setDialogView] = React.useState(<></>);
  const [dialogTitle, setDialogTitle] = React.useState(<></>);
  const [page, setPage] = React.useState<boolean>(0);

  const handlePages = (newPage: boolean) => {
    setPage(newPage);
    roomViewDialogOpen('signIn', newPage);
  };

  const roomViewDialogClose = (v = '') => {
    if (v === 'signIn') {
      handleClick();
    }
    setDialog(false);
  };

  const roomViewDialogOpen = (v, pg = 0) => {
    if (v === 'selectRoom') {
      setDialogView(
        <SelectRoom
          dialog={true}
          setRoomSceneDimension={setRoomSceneDimension}
          roomViewDialogClose={roomViewDialogClose}
        />,
      );
      setDialogTitle(
        <Typography variant="h6" className="AccountHeading">
          <b>Select Room</b>
        </Typography>,
      );
    } else if (v === 'selectGroutColor') {
      setDialogView(<SelectGroutColors dialog={true} />);
      setDialogTitle(
        <Typography variant="h6" className="AccountHeading">
          <b>Select Grout Color</b>
        </Typography>,
      );
    } else {
      setDialogView(
        <SignIn page={pg} handlePages={handlePages} closeDrawer={roomViewDialogClose} />,
      );
      setDialogTitle(
        <Box>
          <MainLogo />
        </Box>,
      );
    }
    setDialog(true);
  };

  return (
    <Grid container direction="row">
      <Grid size={12}>
        <Grid container direction="row" className="LightSkyBlue GridRow">
          <Grid size={12}>
            <Paper className="GroutBox">
              <Box className="ChangeRoomBox">
                <Button
                  className="CommonGrayButton ChangeRoom"
                  variant="outlined"
                  onClick={() => roomViewDialogOpen('selectRoom')}
                >
                  Change Room
                </Button>
                <Box>
                  <Button
                    aria-describedby={id}
                    className="CommonGrayButton SaveScene"
                    variant="outlined"
                    onClick={handleClick}
                    disabled={saveButton === 'Scene Saved '}
                  >
                    {saveButton}
                  </Button>
                  <Popover
                    id={id}
                    open={opensecond}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    className="OptionsPopover"
                  >
                    <Box className="OptionsPopoverBox">
                      <List>
                        <ListItem disablePadding>
                          <Link>
                            <CreateNewFolderOutlinedIcon /> Add to Saved Scenes
                          </Link>
                        </ListItem>
                        <ListItem disablePadding>
                          <Link>
                            <FileDownloadOutlinedIcon /> Download Specifications
                          </Link>
                        </ListItem>
                      </List>
                    </Box>
                  </Popover>
                </Box>
              </Box>
              <Box className="GroutCanvas ViewRoomCanvas">
                <div className="container">
                  {roomSceneDimension ? (
                    <Render
                      roomData={roomSceneData}
                      noPerspective={!roomSceneData?.surface[0]?.perspective}
                      canvasRef={canvasRef}
                    />
                  ) : (
                    <>Loading....</>
                  )}
                  <img
                    style={{ maxWidth: 400, height: 'auto' }}
                    src={roomSceneData?.src}
                    id="myImage"
                    onLoad={onRoomSceneLoad}
                  />
                </div>
              </Box>
            </Paper>
          </Grid>
        </Grid>
        {/* <img src={test} style={{ maxWidth: '400px', height: 'auto' }} /> */}
        <Container maxWidth="sm" disableGutters>
          <Grid container direction="row" className="GridRow GridRowSecond">
            <Grid size={12}>
              <Paper className="TileGroutOptions">
                <Typography variant="h4" sx={{ mb: 3, textAlign: 'center' }}>
                  Customize Grout & Tile
                </Typography>
                <Box className="TabContainer">
                  <Box className="TabHeader">
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                      <Tab label="Grout Color & Size" {...a11yProps(0)} />
                      <Tab label="Tile Pattern" {...a11yProps(1)} />
                    </Tabs>
                  </Box>
                  <Box className="TabContent">
                    <TabPanel value={value} index={0}>
                      <GroutColorsAndSize
                        groutColors={selectedGroutColorData}
                        handleColorClick={handleColorClick}
                        handleColorDelete={handleColorDelete}
                        handleAddColor={handleAddColor}
                        handleGroutWidth={handleGroutWidth}
                        toggleDrawer={toggleDrawer}
                        groutWidth={groutWidth}
                      />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                      <TilePattern
                        handlePattern={handlePattern}
                        pattern={installation}
                        selectedTileData={selectedTileData}
                        tile={roomSceneData?.tile}
                      />
                    </TabPanel>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid size={12} className="LeftRightButtonBox">
              <Button
                variant="contained"
                color="primary"
                startIcon={<KeyboardArrowLeftOutlinedIcon />}
                onClick={handleBack}
              >
                Back
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <BottomDrawer
        title={dialogTitle}
        open={dialog}
        view={dialogView}
        close={roomViewDialogClose}
      />
    </Grid>
  );
};

export default ViewRoom;
